import { Dtos, UserId } from "@inrev/common";
import { useQuery } from "@tanstack/react-query";
import { ADMIN_BASE_URL } from "../../../constants";
import { useRequest } from "../../../utils/request";
import { trailing90DayGwpQueryKey } from "../dashboard.keys";

type Trailing90DayGwp = Dtos.Admin.SuretyBond.Trailing90DayGwp.Get.Response;

export const useFetchTrailing90DayGwp = (underwriterUserId?: UserId) => {
	const { get } = useRequest();

	const { data, error, isLoading } = useQuery({
		queryKey: trailing90DayGwpQueryKey(underwriterUserId),
		queryFn: async () =>
			await get<Trailing90DayGwp>(
				`${ADMIN_BASE_URL}/surety/bonds/trailing-90-day-gwp${
					underwriterUserId ? `?underwriterUserId=${underwriterUserId}` : ""
				}`,
			),
	});

	return {
		trailing90DayGwp: data,
		trailing90DayGwpError: error,
		trailing90DayGwpIsLoading: isLoading,
	};
};
